(() => {
    let attempts = 0;
    const maxAttempts = 10;
    const interval = 1000;
    let listenersBound = false;
  
    const getIndigoTracker = () => window.IndigoAiChat || window.IndigoAIChat;
  
    const pushTrackingEvent = (eventName, payload) => {
      console.log('[IndigoTracker] pushTrackingEvent', eventName, payload);
      const normalizedName = eventName.replace(/:/g, '_');
      const trackingPayload = {
        event: `indigo_chat_${normalizedName}`,
        indigoChatEvent: eventName,
        indigoChatPayload: payload ?? null,
      };
  
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(trackingPayload);
      } else {
        // eslint-disable-next-line no-console
        console.log('[IndigoTracker]', trackingPayload);
      }
    };
  
    const getPayloadString = (data) => {
      if (!data) {
        return null;
      }
      if (typeof data.payload === 'string') {
        return data.payload;
      }
      if (data.message && typeof data.message.payload === 'string') {
        return data.message.payload;
      }
      return null;
    };
  
    const detectSpecialEvent = (data) => {
      console.log('[IndigoTracker] detectSpecialEvent', data);
      const isFeedback = data?.feedback;
  
      if (isFeedback) {
        return {
          event: 'chatbot_feedback',
          payload: data,
        };
      }
  
      return null;
    };
  
    const attachListeners = (tracker) => {
      if (!tracker || listenersBound || typeof tracker.on !== 'function') {
        return;
      }
  
      const eventsMap = {
        open: () => pushTrackingEvent('open'),
        close: () => pushTrackingEvent('close'),
        ready: () => pushTrackingEvent('ready'),

        '$set-open': (isOpen) => {
          if (isOpen) {
            pushTrackingEvent('widget:opened', { isOpen: true });
          } else {
            pushTrackingEvent('widget:closed', { isOpen: false });
          }
        },

        '$message-sent': (message) => {
          if (message.type === 'text') {
            pushTrackingEvent('message:sent', message);
  
            const specialEvent = detectSpecialEvent(message);
            if (specialEvent) {
              pushTrackingEvent(specialEvent.event, {
                source: 'message:sent',
                payload: specialEvent.payload,
              });
            }
          }
        },
        '$message-received': (message) => {
          if (message.type === 'text') {
            pushTrackingEvent('message:received', message);
  
            const specialEvent = detectSpecialEvent(message);
            if (specialEvent) {
              pushTrackingEvent(specialEvent.event, {
                source: 'message:received',
                payload: specialEvent.payload,
              });
            }
          }
        },
        '$conversation-start': (context) => pushTrackingEvent('conversation:start', context),
        '$conversation-end': (context) => pushTrackingEvent('conversation:end', context),
        '$user-data-sent': (strings) => pushTrackingEvent('user-data-sent', strings),
      };
  
      Object.entries(eventsMap).forEach(([eventName, handler]) => {
        tracker.on(eventName, handler);
      });
  
      listenersBound = true;
    };
  
    const extractProductDataFromUrl = (href) => {
      try {
        const url = new URL(href);
        const parts = url.pathname.split('/').filter(Boolean);
        const productsIndex = parts.indexOf('products');
        const slug = productsIndex >= 0 ? parts[productsIndex + 1] || null : null;
        const variantId = url.searchParams.get('variant') || null;
        return { slug, variantId };
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('[IndigoTracker] Unable to parse product url', href, err);
        return { slug: null, variantId: null };
      }
    };
  
    const listenForClickEvents = () => {
      console.log('[IndigoTracker] listenForClickEvents init');
      // trova l'iframe del widget
      const iframe = document.querySelector('#iaw-chat iframe');
      console.log('[IndigoTracker] iframe element', iframe);
  
      if (!iframe) return;
  
      const bind = () => {
        const doc = iframe.contentDocument;
        if (!doc) return;
        doc.addEventListener('click', (e) => {
          console.log('[IndigoTracker] iframe click event', e);
          
          const link = e.target.closest('a');
          if (!link) return;
          const href = link.href;
          
          const detectProductSuggestions = href.includes("product_agent");
          if (detectProductSuggestions) {
            const { slug, variantId } = extractProductDataFromUrl(href);
            pushTrackingEvent('chatbot_suggested_product_click', { href, productSlug: slug, variantId });
          }
  
          const detectCollectionSuggestions = href.includes("collection_agent");
          if (detectCollectionSuggestions) {
            pushTrackingEvent('chatbot_suggested_collection_click', href);
          }
        }, true);
      };
  
      iframe.addEventListener('load', bind);
      bind();
    };

    const trackIndigoAIChat = () => {
      const indigoTracker = getIndigoTracker();

      if (!indigoTracker) {
        attempts += 1;
        if (attempts > maxAttempts) {
          console.warn('[IndigoTracker] Tracker not available after max attempts');
          return;
        }
        console.info(
          `[IndigoTracker] Tracker not ready, retrying in ${interval}ms (attempt ${attempts}/${maxAttempts})`,
        );
        setTimeout(trackIndigoAIChat, interval);
        return;
      }

      attachListeners(indigoTracker);
      console.info('[IndigoTracker] attachListeners executed');
      listenForClickEvents();
      console.info('[IndigoTracker] listenForClickEvents executed');
    };
  
    trackIndigoAIChat();
  })();